import { SharePointInputTypes } from "../../../../config/sharepointConstants";
import { SearhApiInputEnum } from "../../../enums/SearhApiInputEnum";

export class SearhApiInputResolver {
  static SearchApiDictionary = {
    [SearhApiInputEnum.contentType.toString()]: "ContentType",
    [SearhApiInputEnum.text.toString()]: "Text",
    [SearhApiInputEnum.choice.toString()]: "Choice",
    [SearhApiInputEnum.dateTime.toString()]: "DateTime",
    [SearhApiInputEnum.boolean.toString()]: "Boolean",
    [SearhApiInputEnum.number.toString()]: "Number",
    [SearhApiInputEnum.taxonomy.toString()]: "Taxonomy",
    [SearhApiInputEnum.user.toString()]: "User",
    [SearhApiInputEnum.lookup.toString()]: "Lookup"
  };

  private static validTextType = [SharePointInputTypes.text, SharePointInputTypes.url, SharePointInputTypes.note];
  private static validNumberType = [
    SharePointInputTypes.number,
    SharePointInputTypes.numberPercentage,
    SharePointInputTypes.currency
  ];
  private static validChoice = [SharePointInputTypes.choice, SharePointInputTypes.multiChoice];
  private static validUser = [SharePointInputTypes.user, SharePointInputTypes.userMulti];
  private static validTaxonomy = [SharePointInputTypes.taxonomyFieldType, SharePointInputTypes.taxonomyFieldTypeMulti];
  private static validLookup = [SharePointInputTypes.lookupSingle, SharePointInputTypes.lookupMulti];

  static resolveSharepointTypeToApiEnumType(type: string) {
    if (SearhApiInputResolver.validTextType.some(item => item === type)) return SearhApiInputEnum.text;
    if (SearhApiInputResolver.validNumberType.some(item => item === type)) return SearhApiInputEnum.number;
    if (SearhApiInputResolver.validChoice.some(item => item === type)) return SearhApiInputEnum.choice;
    if (SearhApiInputResolver.validUser.some(item => item === type)) return SearhApiInputEnum.user;
    if (SearhApiInputResolver.validTaxonomy.some(item => item === type)) return SearhApiInputEnum.taxonomy;
    if (SearhApiInputResolver.validLookup.some(item => item === type)) return SearhApiInputEnum.lookup;
    if (type === SharePointInputTypes.Boolean) return SearhApiInputEnum.boolean;
    if (type.toLowerCase() === SharePointInputTypes.datetime.toLowerCase()) return SearhApiInputEnum.dateTime;

    return SearhApiInputEnum.contentType;
  }

  static getApiType(type: SearhApiInputEnum): string {
    return SearhApiInputResolver.SearchApiDictionary[type.toString()];
  }
}
